import React, { useEffect, useState } from 'react';
import { Button, FormControl, MenuItem, Select } from '@mui/material';

import { useDispatch } from 'react-redux';
import { apiSlice } from '../../../app/api/apiSlice';

import { useGetPeriodsQuery } from '../../../services/PaymentToolApi';

// period item example in periodsArray
// {
//   "id": 3,
//   "year": 2023,
//   "startDate": "2023-01-16T00:00:00",
//   "endDate": "2023-01-22T23:59:59.997",
//   "isCompleted": false
// }
function getPeriods(periodsArray, selectedYear) {
  //filter periods by year
  periodsArray = periodsArray.filter(period => period.year == selectedYear);

  //filter periods that are in the future, must include the current day
  let currentDate = new Date();
  periodsArray = periodsArray.filter(period => new Date(period.startDate) <= currentDate);

  //sort periods by date, from newest to oldest
  periodsArray.sort((a, b) => new Date(b.startDate) - new Date(a.startDate));
  
  return periodsArray.map(period => ({
    start: period.startDate.split('T')[0],
    end: period.endDate.split('T')[0]
  }));
}

function getOptionValue(start, end) {
  function reformatDate(dateStr) {
    let parts = dateStr.split("-");
    return `${parts[1]}/${parts[2]}/${parts[0]}`;
  }

  let startFormatted = reformatDate(start);
  let endFormatted = reformatDate(end);
  return `${startFormatted}-${endFormatted}`;
}

function periodsToOptions(periodsFromApi, selectedYear) {
  let periods = getPeriods(periodsFromApi, selectedYear);
  return periods.map((period, index) => (
    <MenuItem key={index} value={getOptionValue(period.start, period.end)}>
      {getOptionValue(period.start, period.end)}
    </MenuItem>
  ));
}

const PeriodFilters = ({selectedYear, selectedPeriod, setSelectedYear, setSelectedPeriod, years, userId }) => {
  const dispatch = useDispatch();
  const {data: periods, isLoading: isLoadingPeriods, isFetching: isFetchingPeriods, error: errorPeriods} = useGetPeriodsQuery();
  const [periodsForYear, setPeriodsForYear] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);

  const invalidateCache = () => {
    if(userId) {
      dispatch(apiSlice.util.invalidateTags(['userMetrics', 'transactionSummary', 'period']));
    } else if (selectedYear && selectedPeriod) {
      dispatch(apiSlice.util.invalidateTags(['periodMetrics', 'transactionSummary', 'period']));
    } else {
      dispatch(apiSlice.util.invalidateTags(['yearMetrics', 'transactionSummary']));
    }
  };

  function onChangeYear(e) {
    if (e.target.value == "") return setSelectedYear("");
    let year = parseInt(e.target.value);
    setSelectedYear(year);
    
    // Get periods for the selected year and find the latest one
    const periodsForSelectedYear = getPeriods(periods || [], year);
    setPeriodsForYear(periodsToOptions(periods || [], year));
    
    // Select the first period (which is the latest due to our sorting in getPeriods)
    if (periodsForSelectedYear.length > 0) {
      const latestPeriod = periodsForSelectedYear[0];
      setSelectedPeriod(getOptionValue(latestPeriod.start, latestPeriod.end));
    }
  }

  useEffect(() => {
    setPeriodsForYear( periodsToOptions(periods || [], selectedYear) );
  }
  , [periods]);

  return (
    <div style={{ margin: '0', padding: '0', display:'flex', justifyContent:'flex-end', width:'100%' }} >
      {/* Select components for year, period and user */}
      <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end', flexWrap: 'wrap' }} >
        <FormControl style={{ margin: '0 0 0.5em 0' }}>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <p style={{ fontSize: 'var(--p2)', margin: '0 0.25em 0 0' }}>Year:</p>
            <Select
              sx={{ height: '36px', width: '100px', margin: '0 1em 0 0', borderRadius: '8px' }}
              onChange={onChangeYear}
              value={selectedYear}
            >
              {years.map(year => <MenuItem key={year} value={year}>{year}</MenuItem>)}
            </Select>
          </div>
        </FormControl>

        <FormControl style={{ margin: '0 0 0.5em 0' }}>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', flexWrap:'wrap', justifyContent:'flex-end' }}>
            <p style={{ fontSize: 'var(--p2)', margin: '0 0.25em 0 0', whiteSpace: 'nowrap' }}>Select Remittance Period:</p>
            <Select
              sx={{ height: '36px', width: '200px', margin: '0 1em 0 0', borderRadius: '8px' }}
              onChange={(e) => setSelectedPeriod(e.target.value)}
              value={selectedPeriod}
            >
              {periodsForYear}
            </Select>
          </div>
        </FormControl>

        <Button variant="outlined" sx={{ margin: '0 0 0.5em 0', width: '100px' }} onClick={() => invalidateCache()}>
          Update
        </Button>
      </div>
    </div>
    
  );
}

export default PeriodFilters;
